import { ITemplate } from 'src/interfaces/templates';
import { IUser } from 'src/interfaces/user';
import { formatMessage } from 'src/components/Lead/WhatsApp/utils/formatMessage';
import { doesMessageHasRandomNumbers } from 'src/components/Lead/WhatsApp/utils/doesMessageHasRandomNumbers';
import {
    ICurrentConversation,
    TCurrentTemplate,
} from '../components/modalTemplates/types';
import { getVariablesTemplates } from './getVariablesTemplates';

const RANDOM_NUMBER_PATTERN = /{{randomNumber\[(\d+),(\d+)\]}}/g;
const RANDOM_NUMBER_PLACEHOLDER = '{{randomNumber}}';
const DEFAULT_RANDOM_NUMBER = 0;

const getRandomNumber = (message: string) => {
    let randomNumber = DEFAULT_RANDOM_NUMBER;
    if (!doesMessageHasRandomNumbers(message)) return randomNumber;

    message.replace(RANDOM_NUMBER_PATTERN, (_, min: string, max: string) => {
        const minNum = parseInt(min, 10);
        const maxNum = parseInt(max, 10);
        randomNumber =
            Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
        return randomNumber.toString();
    });

    return randomNumber;
};

/**
 * Resolves a Twilio template for a conversation: generates its random number,
 * formats the description and builds the options used to send it.
 *
 * @param {ITemplate} template - Template as returned by the API
 * @param {ICurrentConversation} conversation - Conversation the template is sent to
 * @param {IUser} user - Agent sending the template
 * @returns {TCurrentTemplate} Template ready for TemplateSendFactory
 */
export const buildCurrentTemplate = (
    template: ITemplate,
    conversation: ICurrentConversation,
    user: IUser
): TCurrentTemplate => {
    const randomNumber = getRandomNumber(template.message).toString();
    const variables = getVariablesTemplates(conversation, user, {
        randomNumber,
    });

    return {
        _id: template._id,
        title: template.title,
        templateTitle: template.templateTitle,
        description: formatMessage(template.message, variables),
        contentTemplateBuilder: template.contentTemplateBuilder,
        templateType: template.templateType,
        language: template?.language,
        messageWithoutFormat: template.message.replace(
            RANDOM_NUMBER_PATTERN,
            RANDOM_NUMBER_PLACEHOLDER
        ),
        options: { ...variables, randomNumber },
    };
};
